import { createFileRoute } from '@tanstack/react-router';

import { DepositsPage } from '@/features/operator/deposits-page';
import { validateSelectionSearch } from '@/features/operator/list-search';

export const Route = createFileRoute('/_operator/deposits')({
	validateSearch: validateSelectionSearch,
	component: DepositsPage,
});
